// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"588":"fcbce22d","612":"5969a502","625":"ac5743e0","996":"3deb2bf4"}[chunkId] + ".js";
};